import { useGetAllAssessmentsQuery } from "@/app/features/recruitment/assessments/assessment.api";
import CustomTable from "@/components/CustomTable";
import StatusTag from "@/components/StatusTag";
import { DISCLOSER_KEYS, FILTER_KEYS } from "@/constants/keys.constants";
import { useAppDiscloser, useAppFilters } from "@/hooks";
import { EyeIcon, PencilEdit02Icon } from "@/icons";
import { Button, Space, type TableProps } from "antd";
import ManageAssessment from "./_components/AssessmentList/ManageAssessment";
import { normalizeColumnValue } from "@/utils";

const ASSESS_STATUS_CONFIG = [
  {
    label: "Active",
    value: "active",
    className: "status status-success",
  },
  { label: "Draft", value: "draft", className: "status status-yellow" },
];

export default function AssessmentsList() {
  const { page, skip, limit, handlePagination, filters, keyword } =
    useAppFilters(FILTER_KEYS.ASSESS_LIST);

  const { data: assessmentData, isFetching } = useGetAllAssessmentsQuery({
    params: { skip, limit, ...filters, search: keyword },
  });

  const [config, handleOpen, handleClose] = useAppDiscloser(
    DISCLOSER_KEYS.ASSESS_LIST,
  );

  const columns: TableProps<any>["columns"] = [
    {
      title: "Title",
      dataIndex: "title",
      // align: "center",
      render: (val: string) => normalizeColumnValue(val, "N/A", false),
    },

    {
      title: "Passing Mark",
      dataIndex: "passing_mark",
      align: "center",
      render: (val: string) => normalizeColumnValue(val, 0),
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (val: string) => (
        <StatusTag value={val} config={ASSESS_STATUS_CONFIG} />
      ),
    },

    {
      title: "Actions",
      dataIndex: "id",
      align: "end",
      render: (_: string, record: any) => (
        <Space size={8}>
          <Button
            size="small"
            className="action-btn"
            icon={<EyeIcon size={20} />}
            onClick={() => handleOpen({ type: "VIEW", data: record })}
          />

          <Button
            size="small"
            className="action-btn"
            icon={<PencilEdit02Icon size={22} />}
            onClick={() => handleOpen({ type: "UPDATE", data: record })}
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <CustomTable
        page={page}
        limit={limit}
        hideRowSelect
        columns={columns}
        tableRootClassName="border-0 p-0"
        dataSource={assessmentData?.data?.data || []}
        onPaginate={handlePagination}
        customTitle="Assessment List"
        loading={isFetching}
        total={assessmentData?.data?.meta?.total || 0}
      />

      <ManageAssessment
        type={config.type}
        open={config.open}
        id={config.data?.id}
        handleClose={handleClose}
      />
    </div>
  );
}
